import { render, staticRenderFns } from "./NewAddForm.vue?vue&type=template&id=21b6c1d8&scoped=true&"
import script from "./NewAddForm.vue?vue&type=script&lang=js&"
export * from "./NewAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b6c1d8",
  null
  
)

export default component.exports